var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loanable-calendar',{attrs:{"defaultView":_vm.defaultView,"events":_vm.availability,"variant":_vm.variant,"loanable":_vm.loanable,"loading":_vm.loading},on:{"ready":_vm.getAvailability,"view-change":_vm.getAvailability}})}
var staticRenderFns = []

export { render, staticRenderFns }